import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';
import NestedFields from 'app/src/elements/NestedFields';

import { FIELDS, SERVICE_CHARGE_FIELDS, INTEREST_FIELDS } from './new';
import { UPDATE_RECONCILE } from './queries';

const EditReconcile = ({ reconcile, setShowModal, refetch, selects }) => {
  const ADDITIONAL_LINES = {
    serviceChargeAmount: reconcile.serviceChargeAmount || '',
    serviceChargeDate: reconcile.serviceChargeDate || '',
    serviceChargeAccountId: reconcile.serviceChargeAccount?.id || '',
    interestAmount: reconcile.interestAmount || '',
    interestDate: reconcile.interestDate || '',
    interestAccountId: reconcile.interestAccount?.id || '',
  };

  const additionalLines = [{...ADDITIONAL_LINES}];
  const [nestedResources, setNestedResources] = useState(additionalLines);
  const [formStatus, setFormStatus] = useState();


  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({
      fields: FIELDS,
      resource: reconcile,
      nestedFields: [
        {
          nestedResources,
          prefix: 'serviceChargeAttributes',
          fields: SERVICE_CHARGE_FIELDS,
        },
        {
          nestedResources,
          prefix: 'interestAttributes',
          fields: INTEREST_FIELDS,
        }
      ],
    })
  });

  const [updateReconcile] = useMutation(UPDATE_RECONCILE, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    input['serviceChargeAmount'] = input['serviceChargeAttributes'][0].serviceChargeAmount !== '' ?
      input['serviceChargeAttributes'][0].serviceChargeAmount : null
    input['serviceChargeDate'] = input['serviceChargeAttributes'][0].serviceChargeDate !== '' ?
      input['serviceChargeAttributes'][0].serviceChargeDate : null
    input['serviceChargeAccountId'] = input['serviceChargeAttributes'][0].serviceChargeAccountId !== '' ?
      input['serviceChargeAttributes'][0].serviceChargeAccountId : null
    input['interestAmount'] = input['interestAttributes'][0].interestAmount !== '' ?
      input['interestAttributes'][0].interestAmount : null
    input['interestDate'] = input['interestAttributes'][0].interestDate !== '' ?
      input['interestAttributes'][0].interestDate : null
    input['interestAccountId'] = input['interestAttributes'][0].serviceChargeAccountId !== '' ?
      input['interestAttributes'][0].interestAccountId : null
    setFormStatus('submitting');
    updateReconcile({ variables: prepareInput(input, FIELDS) });
  });

  const fields = { ...FIELDS };
  fields.accountId.select = selects.accounts;

  const serviceChargeFields = { ...SERVICE_CHARGE_FIELDS };
  serviceChargeFields.serviceChargeAccountId.select = selects.accounts;

  const interestFields = { ...INTEREST_FIELDS };
  interestFields.interestAccountId.select = selects.accounts;

  return (
    <View>
      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      <NestedFields
        prefix="serviceChargeAttributes"
        resources={nestedResources}
        fields={serviceChargeFields}
        control={control}
        errors={errors}
      />

      <NestedFields
        prefix="interestAttributes"
        resources={nestedResources}
        fields={interestFields}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Update Reconcile" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default EditReconcile;
